export default "__VITE_ASSET__0f583221__"